import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import Navbar from './Navbar';
import Footer from './Footer';
import { EASE } from './ui/Reveal';

function SiteLayout() {
  const location = useLocation();
  const reduce = useReducedMotion();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    // overflow-x-clip: 좌우에서 슬라이드 인 하는 요소가 대기 중일 때 가로 스크롤이 생기지 않게 막는다.
    // (overflow-hidden과 달리 스크롤 컨테이너를 만들지 않아 내부 position: sticky가 그대로 동작한다)
    <div className="flex min-h-[100dvh] flex-col overflow-x-clip">
      <Navbar />
      <main className="flex-1 overflow-x-clip pt-16 sm:pt-[68px]">
        <motion.div
          key={location.pathname}
          initial={reduce ? false : { opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, ease: EASE }}
        >
          <Outlet />
        </motion.div>
      </main>
      <Footer />
    </div>
  );
}

export default SiteLayout;
